// get user
export const GET_USER_REQUEST = "my-account/GET_USER_REQUEST";
export const GET_USER_SUCCESS = "my-account/GET_USER_SUCCESS";
export const GET_USER_ERROR = "my-account/GET_USER_ERROR";
export const CLEAR_ACCOUNT_DATA = "my-account/CLEAR_ACCOUNT_DATA";
